import React, { useEffect, useState } from 'react';
import { countryCodes } from '../../config/keys';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { isEmptyVar } from '../../utils/VariableUtil';

const refModalImages = React.createRef();
const defaultWeights = { entries: 24.5, xp: 24.5, giftcard: 1 };

function LevelsConfig(props) {
  const [scratchDrawWeights, setScratchDrawWeights] = useState(defaultWeights);
  const [levelSaved, setLevelSaved] = useState(false);
  const [notifications, setNotifications] = useState({ entries: {}, giftcard: {}, xp: {} });
  const [imageField, setImageField] = useState(null);
  const [levelUpContestList, setLevelUpContests] = useState([]);
  const [contests, setContests] = useState({ CA: {}, US: {} });
  const { firestore, levelsConfig, levelUpContests, images } = props;

  useEffect(() => {
    M.AutoInit();
    M.updateTextFields();
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }, []);

  useEffect(() => M.AutoInit(), [levelUpContestList]);

  useEffect(() => {
    if (!levelUpContests) return;
    const contestList = [];
    Object.keys(levelUpContests).forEach((key) => {
      contestList.push(levelUpContests[key]);
    });
    setLevelUpContests(contestList);
  }, [levelUpContests]);

  useEffect(() => {
    if (!levelsConfig) return;
    setScratchDrawWeights(levelsConfig.SCRATCH_DRAW_WEIGHTS);
    setNotifications(levelsConfig.NOTIFICATIONS);
    setContests(levelsConfig.CONTESTS);
  }, [levelsConfig]);

  const validLevelsConfig = () =>
    !isEmptyVar(scratchDrawWeights.entries) && !isEmptyVar(scratchDrawWeights.xp) && !isEmptyVar(scratchDrawWeights.giftcard) && !isEmptyVar(notifications.entries.title) && !isEmptyVar(notifications.xp.title) && !isEmptyVar(notifications.giftcard.title) && validContests();

  const validContests = () => {
    for (const countryCode of Object.keys(contests)) {
      const id = contests[countryCode].contestId;
      if (countryCode !== 'updatedAt' && isEmptyVar(id)) return false;
    }
    return true;
  };

  const saveLevelsConfig = (e) => {
    e.preventDefault();
    if (!validLevelsConfig()) {
      M.toast({ html: 'Fill in all the fields' });
      return;
    }
    Promise.all([
      saveLevelsConfigById('CONTESTS', { ...contests, updatedAt: firestore.FieldValue.serverTimestamp() }),
      saveLevelsConfigById('NOTIFICATIONS', { ...notifications, updatedAt: firestore.FieldValue.serverTimestamp() }),
    ])
      .then(() => setLevelSaved(true))
      .catch((e) => M.toast({ html: `Error: ${e.message ? e.message : e}` }));
  };

  const saveLevelsConfigById = (id, levelConfig) => firestore.collection('levelsConfig').doc(id).set(levelConfig);

  const openImageDialog = (onChoose) => {
    setImageField({ onChoose });
    M.Modal.getInstance(refModalImages.current).open();
  };

  const closeImagesModal = () => {
    const modal = document.getElementById('modalImages');
    M.Modal.getInstance(modal).close();
  };

  const renderImagesDialog = () => {
    return (
      <div ref={refModalImages} id="modalImages" className="modal">
        <div className="modal-content">{renderImages()}</div>
      </div>
    );
  };

  const renderImages = () =>
    !images ? null : (
      <div>
        <h5>Select an image:</h5>
        <div className="row">{Object.keys(images).map((imageId) => image(imageId, images))}</div>
      </div>
    );

  const image = (imageId, images) => (
    <div
      key={imageId}
      className="col s2"
      onClick={() => {
        imageField.onChoose(images[imageId].url);
        closeImagesModal();
      }}>
      <img src={images[imageId].url} width="100" height="100" alt="" />
      <br />
    </div>
  );

  const renderNotifications = () => (
    <div>
      <h5>Notifications for Level Up claimed rewards</h5>
      {renderNotificationsSection('Entries', 'entries')}
      {renderNotificationsSection('XP', 'xp')}
      {renderNotificationsSection('Gift Card', 'giftcard')}
    </div>
  );

  const renderNotificationsSection = (title, section) => (
    <div>
      <h6>{title}</h6>
      <div className="row">
        {textInput('Title', notifications[section].title, 2, '', (e) => setNotifications({ ...notifications, [section]: { ...notifications[section], title: e.target.value } }))}
        {textInput('Message', notifications[section].message, 10, '', (e) => setNotifications({ ...notifications, [section]: { ...notifications[section], message: e.target.value } }))}
      </div>
      <div className="row">
        {notifications[section].icon ? <img className="col s1" src={notifications[section].icon} alt="" /> : null}
        {textInput('Icon url', notifications[section].icon, notifications[section].icon ? 11 : 12, '', false, () => openImageDialog((e) => setNotifications({ ...notifications, [section]: { ...notifications[section], icon: e } })))}
      </div>
    </div>
  );

  const renderContests = () => (
    <div>
      <h5>Level Up Contest IDs</h5>
      {Object.keys(countryCodes).map((countryCode) => (
        <div key={countryCode} className="row" style={{ display: 'flex', alignItems: 'center' }}>
          <p className="col s1">{countryCode}</p>
          {renderContestsSelect(countryCode)}
        </div>
      ))}
    </div>
  );

  const renderContestsSelect = (countryCode) => {
    return (
      <div className="col s11">
        <select
          value={contests[countryCode] ? contests[countryCode].contestId || '' : ''}
          onChange={(e) => {
            setContests({ ...contests, [countryCode]: { ...contests[countryCode], contestId: e.target.value } });
          }}>
          <option value="" disabled>
            Choose a contest
          </option>
          {levelUpContestList.map((contest) => renderContestOption(contest))}
        </select>
        <label>Contest</label>
      </div>
    );
  };

  const renderContestOption = (contest) => {
    return (
      <option key={contest.id} value={contest.id}>
        {`${contest.name} (${contest.countryCode})`}
      </option>
    );
  };

  const textInput = (label, value, colSize, placeholder, setData = () => {}, onClick = () => {}) => (
    <div className={`input-field col s${colSize}`}>
      <input id={`${label}${value}`} type="text" className="validate" value={value || ''} onChange={(e) => setData(e)} placeholder={placeholder} onClick={() => onClick()} />
      <label htmlFor={`${label}${value}`} className="active">
        {label}
      </label>
    </div>
  );

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (levelSaved) return <Redirect to="/levels" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            {renderImagesDialog()}
            <div className="row">
              <div className="col s12">
                <h4>Levels Config</h4>
              </div>
            </div>
            {renderNotifications()}
            {renderContests()}
          </div>
          <div className="card-action">
            <button className="waves-effect waves-light btn-small" onClick={(e) => saveLevelsConfig(e)}>
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    levelsConfig: state.firestore.data.levelsConfig,
    auth: state.firebase.auth,
    images: state.firestore.data['images'],
    levelUpContests: state.firestore.data['levelUpContests'],
  };
};

export default compose(
  firestoreConnect([
    { collection: 'levelsConfig' },
    { collection: 'images', where: ['tags', 'array-contains', 'notification'], storeAs: 'images' },
    { collection: 'contests', where: ['actions', 'array-contains', 'LEVEL_UP'], storeAs: 'levelUpContests' },
  ]),
  connect(mapStateToProps),
)(LevelsConfig);
